/**
 * Shared sizing/typography tokens for mobile screens.
 *
 * Mobile pages and the primitives in `src/components/shared/` read from here so control heights,
 * touch targets, and page padding stay identical across tabs instead of drifting per call site.
 */
export const MOBILE_UI = {
  /** Horizontal + top padding for a mobile page shell. */
  pagePadding: 12,
  gap: 12,
  sectionGap: 16,
  radiusCard: 12,
  radiusControl: 10,
  radiusChip: 999,
  /** Minimum hit area for icon-only buttons. */
  touchMin: 44,
  chipHeight: 40,
  /** Selects / inputs inside sheets. */
  controlHeight: 44,
  rowMinHeight: 56,
  font: {
    title: 16,
    section: 13,
    body: 13,
    meta: 11,
  },
};

export default MOBILE_UI;
